<template>
  <span
    class="status_tag"
    :style="{color: colorTable[status]}"
  >
    <span
      :class="[status === 2 ? 'end' : 'start']"
      v-text="text"
    />
  </span>
</template>

<script type="text/ecmascript-6">
// 1:启用；2:停用
export default {
  props: {
    status: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      colorTable: {
        1: '#42c27e',
        2: '#f57676'
      }
    }
  },
  computed: {
    text () {
      return this.status === 2 ? this.stopOpen[0] : this.stopOpen[1]
    },
    stopOpen () {
      return this.$t('message["1204"]').split('|')
    }
  }
}
</script>

<style scoped lang="scss">
.status_tag {
  position: relative;
  background: #fff;
  font-size: 12px;
  box-sizing: border-box;
  border: 1px solid #ebebeb;
  border-radius: 4px;
  padding: 2px 4px 2px 12px;
  .start::before, .end::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 4px;
    transform: translateY(-50%);
    width: 4px;
    height: 4px;
    border-radius: 50%;
    background: #b3b3b3;
  }
  .start::before {
    background: #42c27e
  }
  .end::before {
    background: #f57676
  }
}
</style>
